export default "__VITE_ASSET__CW$XzXWZ__"